export default __webpack_public_path__ + "ea99313e2ebe6cd1282e1a2d9d200473.png";